module.exports = __webpack_public_path__ + "img/authed.f2ecb50a.png";